import { type RequestPlugin } from '@direct-frontend/modules-request';
import { getWindow } from '../../../../lib/getWindow';

type AuthorizePluginOptions = {
    try: number;
};

export type AuthorizePlugin = () => Required<Pick<RequestPlugin<AuthorizePluginOptions>, 'onEnd'>>;

export const authorizePlugin: AuthorizePlugin = () => {
    return {
        async onEnd(response, _error) {
            const { data, status } = response;

            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- generic response
            const hasNotAccess = status === 403 && (data as any)?.code === 'no_write_access';

            if (hasNotAccess) {
                const NoAccessEvent = new CustomEvent('userDoesNotHaveAnAccess');

                getWindow()?.dispatchEvent(NoAccessEvent);
            }

            return response;
        },
    };
};
